import {
  APP_FETCH_REQUEST,
  APP_FETCH_REQUEST_SUCCESS,
  APP_FETCH_REQUEST_FAILURE,
  APP_ADD_REQUEST,
  APP_ADD_REQUEST_SUCCESS,
  APP_ADD_REQUEST_FAILURE,
  APP_UPDATE_REQUEST,
  APP_UPDATE_REQUEST_SUCCESS,
  APP_UPDATE_REQUEST_FAILURE,
  APP_CLEAN_REQUEST,
  APP_CATEGORY_IMPORT_REQUEST,
  APP_CATEGORY_IMPORT_REQUEST_SUCCESS,
  APP_CATEGORY_IMPORT_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const appsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case APP_FETCH_REQUEST:
    case APP_ADD_REQUEST:
    case APP_UPDATE_REQUEST:
    case APP_CATEGORY_IMPORT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case APP_FETCH_REQUEST_SUCCESS:
    case APP_ADD_REQUEST_SUCCESS:
    case APP_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case APP_CATEGORY_IMPORT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case APP_FETCH_REQUEST_FAILURE:
    case APP_ADD_REQUEST_FAILURE:
    case APP_UPDATE_REQUEST_FAILURE:
    case APP_CATEGORY_IMPORT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case APP_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default appsReducer;
